/**
* In Profile function is used to display the Admin details and its functions declare this file 
**/
import { goBack } from './../../../services/UtilsService';
import {Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
//import { useSelector } from 'react-redux'
import {convertS3privateToPublic} from './../../../services/UtilsService';
import ApiService from './../../../services/ApiService';
import { useTranslation } from 'react-i18next';

function Profile() {
	//Initial variable declaration
	//const profileData=useSelector(state => state?.profile);
	const [data,setData]=useState({});
	const { t } = useTranslation();

	//components initialize function and api handling
	useEffect(()=>{
		(async()=>{
			var response = await ApiService.getProfile();
			if(response.status===200)
				setData({...response?.data?.profile});
		})();
	},[]);

	return(
	<main id="main" className="main">
	
	{/* Page Title Section */}
	<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('header.myProfile')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/hospital/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('header.myProfile')}</li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
	</div>
	{/*End Page Title Section*/}
		
		{/*Page Content Section*/}
		<div className="row">
			
			<div className="col-lg-4">
				{/*Profile Image*/}
				<div className="card profile-img">
					<div className="card-body">
						<div className="top-bar">
							<img className="img-fluid d-block mx-auto" src={data?.photo==='default.png'?"/assets/img/user-avatar.png":convertS3privateToPublic(data?.photo)} alt="logo" />
							<h1 className="text-capitalize">{data?.first_name+' '+data?.last_name}</h1>
						</div>
						<div className="center-bar clearfix">
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon admin-info-icon">
									<i className="iconly-Bold-Send"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmAquaDgreen">{t('profile.email')}</p>
									<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{data?.email}</span>
								</div>
							</div>
						</div>
						<div className="d-grid mt-4">
							<Link to='/hospital/admin/edit-profile'  className="btn btn-block btn-tmAquaDgreen">
								<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
							</Link>
						</div>
					</div>
				</div>
            </div>
			
			<div className="col-lg-8">
				<div className="card profile-info">
					<div className="card-body pt-4">
						{/*Admin Info*/}
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle admin-secTitle">
									<h1>{t('profile.profileInfo')}</h1>
								</div>
								<div className="secContent admin-secContent">
									<div className="row">
										<div className="col-lg-4 px-3">
											<h6>{t('profile.adminName')}</h6>
											<p>{data?.first_name+' '+data?.last_name}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.role')}</h6>
											<p>{t('profile.hospitalAdminRole')}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.phoneNumber')}</h6>
											<p>{data?.phoneNumber?data?.phoneNumber:'--'}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.emailAddress')}</h6>
											<p>{data?.email?data?.email:'--'}</p>
										</div>
										{/* <div className="col-lg-4 px-3">
											<h6>{constantVariables.profile.gender}</h6>
											<p>{data?.gender === 0 ? 'Male' : data?.gender === 1 ? 'Female' : '--'}</p>
										</div> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
		{/*End Page Content Section*/}
	</main>
	);
}

export default Profile;
